import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import React, { useMemo } from 'react';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import DENTDentalCross from '../DENTDentalCross/DENTDentalCross';
import MeddiDENTCreateHealthPlan from './MeddiDENTCreateHealthPlan/MeddiDENTCreateHealthPlan';
import DENTHistory from '../DENTHistory/DENTHistory';

interface Props {
	patientId: string;
	onHealthPlanCreate: () => void;
}

const MeddiDENTHealthPlan = ({ patientId, onHealthPlanCreate }: Props) => {
	const { healthPlanUser } = useHealthPlanContext();

	const steps: NavigationStepperItemType[] = useMemo(() => {
		const tempSteps: NavigationStepperItemType[] = [];

		if (healthPlanUser) {
			tempSteps.push(
				{
					name: 'patientTreatment.meddiDENT.dentalCross.title',
					key: 'dentalCross',
					component: (params: NavigationStepperComponentParams) => (
						<DENTDentalCross />
					),
				},
				// {
				// 	name: 'patientTreatment.meddiDENT.treatmentPlan.title',
				// 	key: 'treatmentPlan',
				// 	component: (params: NavigationStepperComponentParams) => (
				// 		<div>Zatím neimplentováno</div>
				// 	),
				// },
				{
					name: 'patientTreatment.meddiDENT.history.title',
					key: 'history',
					component: (params: NavigationStepperComponentParams) => (
						<DENTHistory />
					),
				},
				// {
				// 	name: 'patientTreatment.meddiDENT.softTissue.title',
				// 	key: 'softTissue',
				// 	component: (params: NavigationStepperComponentParams) => (
				// 		<div>Zatím neimplentováno</div>
				// 	),
				// },
			);
		} else {
			tempSteps.push({
				name: 'patientTreatment.meddiDENT.createHealthPlan',
				key: 'dentPlanCreate',
				component: () => (
					<MeddiDENTCreateHealthPlan
						patientId={patientId}
						onHealthPlanCreate={onHealthPlanCreate}
					/>
				),
			});
		}

		return tempSteps;
	}, [healthPlanUser]);

	return (
		<SubTabNavigationStepper
			steps={steps}
			initialStepPath={'dentalCross'}
			canSkip={true}
		/>
	);
};

export default MeddiDENTHealthPlan;
